import { Stack, Typography } from '@mui/material'
import { StyledToggle, type ToggleOption } from './StyledToggle'

export type AnnualPlanPhaseName = 'contract' | 'implementation'
interface Props {
  phase: AnnualPlanPhaseName
  onPhaseChange?: (phase: AnnualPlanPhaseName) => void
}

export const AnnualPlanPhaseSwitcher = (props: Props): JSX.Element => {
  const options: Array<ToggleOption<AnnualPlanPhaseName>> = [
    { value: 'contract', label: 'Contract' },
    { value: 'implementation', label: 'Implementation' }
  ]

  return <Stack spacing='.5em' data-testid='annualPlanPhaseSwitcher'>
    <Typography variant='body1' color='rgba(26, 26, 26, 1)'>Currently Viewing</Typography>
    <StyledToggle
      options={options}
      selectedValue={props.phase}
      onSelectionChange={(value) => { props.onPhaseChange?.(value) }}
    />
  </Stack>
}
